import { http } from '../http';
import { RequestConsent } from '../__generated__/api-di';

export const postConsentRequest = async (requestConsent: RequestConsent) => {
  try {
    const response = await http({
      url: '/api/v1/client-consent-request',
      method: 'POST',
      data: JSON.stringify(requestConsent),
    });
    return { data: response.data, status: 200 };
  } catch (err: any) {
    return { status: err.status };
  }
};
